// @ts-nocheck
import React, { useCallback, useState } from 'react';
import { FlatList, Platform, RefreshControl, StyleSheet, useWindowDimensions, View } from 'react-native';
import Button from '../../../components/Button';
import HStack from '../../../components/HStack';
import { useNavigation } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import {
  DeleteAllApprovals,
  GetApprovals,
} from '../../../redux/reducers/approvalsReducer';
import { RootStore } from '../../../redux/store';
import ApprovalItem from '../components/ApprovalItem';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { useFocusEffect } from '@react-navigation/native';
import Text from '../../../components/Text';
import ActiveFiltersSection from '../components/ActiveFiltersSection';
import { VStack } from 'native-base';

const Approvals = () => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const { approvals, loading, filterArgs } = useSelector(
    (state: RootStore) => state.approvals,
  );
  const { height } = useWindowDimensions()
  const [refreshing, setRefreshing] = useState(false);
  const [pendingShown, setPendingShown] = useState(true);

  const { unitLinksHolder } = useSelector((state: RootStore) => state.units);

  const units: Array<{ id: string; name: string }> = unitLinksHolder?.map(
    unitlink => {
      return {
        id: unitlink.unit.id,
        name: unitlink.unitNickname
          ? unitlink.unitNickname
          : unitlink.unit.unitName,
      };
    },
  );

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    dispatch(DeleteAllApprovals());
    dispatch(GetApprovals(pendingShown));
    setRefreshing(false);
  }, [pendingShown, dispatch]);

  useFocusEffect(
    useCallback(() => {
      dispatch(DeleteAllApprovals());
      dispatch(GetApprovals(pendingShown));
    }, []),
  );

  const handleClick = () => {
    setPendingShown(!pendingShown);
    dispatch(DeleteAllApprovals());
    dispatch(GetApprovals(!pendingShown));
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <FlatList
          refreshControl={
            <RefreshControl onRefresh={onRefresh} refreshing={refreshing} />
          }
          style={styles.flatList}
          contentContainerStyle={styles.listContent}
          data={approvals}
          renderItem={({ item }) => (
            <ApprovalItem
              key={item?.id}
              approval={item}
              approvalClickHandler={() =>
                navigation.navigate('Approval Detail', {
                  id: item.id,
                  unitId: item.unit.unitId,
                })
              }
              refreshList={() => {
                dispatch(GetApprovals(pendingShown));
              }}
            />
          )}
          ListHeaderComponent={
            <VStack style={styles.headerContainer}>
              <HStack justifyContent="space-between" alignItems="center">
                <Text style={styles.heading}>
                  {`${pendingShown ? 'Pending' : 'All'} approvals`}
                </Text>
                <Button variant="link" onPress={handleClick}>
                  {`Show ${pendingShown ? 'All' : 'Pending'}`}
                </Button>
              </HStack>
              <ActiveFiltersSection filterArgs={filterArgs} units={units} />
            </VStack>
          }
          ListEmptyComponent={
            <View style={[styles.emptyContainer, {height: height / 2}]}>
              <Text style={styles.emptyText}>{`You have no ${
                pendingShown ? 'pending' : ''
              } approvals`}</Text>
            </View>
          }

        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  flatList: {
    backgroundColor: '#f4f4f5',
    flex: 1,
    marginBottom: Platform.OS === 'ios' ? 140 : 76,
  },
  listContent: {
    paddingBottom: 96,
    paddingTop: 10,
  },
  headerContainer: {
    marginBottom: 4,
  },
  heading: {
    color: '#27272a',
    marginHorizontal: 12,
    paddingVertical: 8,
    fontSize: 13,
    fontWeight: '700',
  },
  emptyContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'center',
  },
  emptyText: {
    color: '#71717a',
    textAlign: 'center',
  },
});

export default Approvals;
